import React, { useCallback } from 'react'
import { useMuiSelectUtils } from 'scenes/Dashboard/components-next/Inputs/Select/Select.hook'
import { Deal } from 'scenes/Dashboard/data/deals/types'
import { ExtendableStyles } from 'utils-next/types'

import { MenuItem, Select, SelectChangeEvent } from '@mui/material'

import { useDealHandlers } from './DealCard.container'

export type DealFitRelevanceProps = ExtendableStyles & {
  deal: Deal
  onChange?: (relevanceScore: number) => void
}
const menuItemsData = [
  { value: '1', text: 'Ideal Match' },
  { value: '.999', text: 'Strong Match' },
  { value: '0.749', text: 'Decent Match' },
  { value: '0.649', text: 'Limited Match' },
]

export function DealFitRelevanceSelector({ deal, onChange }: DealFitRelevanceProps) {
  const { updateDealData } = useDealHandlers(deal.id)
  const mappedFitScore =
    menuItemsData
      .slice()
      .sort((a, b) => Number(a.value) - Number(b.value))
      .find((item) => deal.fitScore && deal.fitScore <= Number(item.value))?.value ?? ''

  const { getItem, selectedItem, setSelectedItem } = useMuiSelectUtils(menuItemsData, mappedFitScore)

  const onSelectChange = useCallback(
    (event: SelectChangeEvent<{ name?: string; value: unknown }>) => {
      const relevanceScore = event.target.value?.toString()
      setSelectedItem(relevanceScore)
      updateDealData({ ...deal, fitScore: Number(relevanceScore) })
    },
    [onChange, deal]
  )

  return (
    <div>
      <span style={{ marginRight: 4, fontWeight: 'bold' }}>Fit Relevance: </span>
      <Select
        variant="standard"
        value={getItem(selectedItem)}
        renderValue={() => getItem(selectedItem)?.text}
        onChange={onSelectChange}
      >
        {menuItemsData.map((m) => (
          <MenuItem key={m.value} value={m.value}>
            {m.text}
          </MenuItem>
        ))}
      </Select>
    </div>
  )
}
